import * as t from 'io-ts';
import { createGuard } from 'src_common/common/createGuard';
import {
    SinglesSingleSelectionType,
    MultiplesSingleSelectionType,
} from 'src/domains/sportsbook/trading/view/Liabilities/LiabilitiesWidgets/LiabilitiesWidgetTable/LiabilitiesWidgetTable.types';

const LiabilitiesValueIO = t.union([t.literal('single'), t.literal('multiple'), t.literal('both')]);
export const isLiabilitiesValue = createGuard(LiabilitiesValueIO);

type ImmutableLiabilityType = Immutable.Map<
    string,
    | string
    | Immutable.Map<string, string | number | Immutable.List<SinglesSingleSelectionType | MultiplesSingleSelectionType>>
>;

export type LiabilityImmutableType = Immutable.Map<string, ImmutableLiabilityType>;
